const isLocal = process.env.NODE_ENV === "development";
const GT_BASE = isLocal
  ? "http://localhost:8888/.netlify/functions/api/gauntlet"
  : "https://webapp.fplnepal.com/.netlify/functions/api/gauntlet";

const CACHE_PREFIX = "fplnepal_gt_v1:";
const memoryCache = new Map();

async function gtJson(path, options = {}) {
  const method = String(options.method || "GET").toUpperCase();
  const url = `${GT_BASE}${path}`;
  if (method === "GET") {
    const ttl = 60 * 1000;
    const now = Date.now();
    const mem = memoryCache.get(url);
    if (mem && now - mem.at < ttl) return mem.data;
    try {
      const raw = localStorage.getItem(CACHE_PREFIX + url);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && now - parsed.at < ttl) { memoryCache.set(url, parsed); return parsed.data; }
      }
    } catch (_) {}
  }
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || `Request failed (${res.status})`);
  if (method === "GET") {
    const record = { at: Date.now(), data }; memoryCache.set(url, record);
    try { localStorage.setItem(CACHE_PREFIX + url, JSON.stringify(record)); } catch (_) {}
  } else {
    memoryCache.clear();
    try { Object.keys(localStorage).filter(k => k.startsWith(CACHE_PREFIX)).forEach(k => localStorage.removeItem(k)); } catch (_) {}
  }
  return data;
}

export const fetchGauntletHome = () => gtJson("/home");
export const fetchGauntletFixtures = (round) => gtJson(`/fixtures${round ? `?round=${encodeURIComponent(round)}` : ""}`);
export const fetchGauntletManagers = () => gtJson("/managers");
export const fetchGauntletBracket = () => gtJson("/bracket");
export const fetchGauntletManager = (id) => gtJson(`/manager/${encodeURIComponent(id)}`);

function adminHeaders(token) { return { "Content-Type": "application/json", "X-Admin-Token": token }; }
export const gauntletAdminStatus = (token) => gtJson("/admin/status", { headers: adminHeaders(token) });
export const gauntletAdminLiveRegistrations = (token) => gtJson("/admin/registrations/live", { headers: adminHeaders(token) });
export const gauntletAdminBootstrap = (token) => gtJson("/admin/bootstrap", { method:"POST", headers:adminHeaders(token), body:"{}" });
export const gauntletAdminSyncGw = (token, gw) => gtJson(`/admin/sync-gameweek/${gw}`, { method:"POST", headers:adminHeaders(token), body:"{}" });
